
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.61 2.3l-1.906-.293a.613.613 0 00-.208 1.208l1.207.212.736 8.9c.088 1.076.967 1.91 2.03 1.91h8.721a2.054 2.054 0 002.023-1.789l.76-5.355c.071-.49.015-1.028-.305-1.404-.32-.375-.64-.546-1.127-.546H5.746a.492.492 0 01-.488-.458l-.152-1.83a.612.612 0 00-.495-.554zm7.087 5.862h2.214a.6.6 0 01.6.613.605.605 0 01-.6.612h-2.214a.605.605 0 01-.6-.612.6.6 0 01.6-.613z","fill":"#94A3B8"}}),_c('path',{attrs:{"d":"M7.548 16.767c0-.686-.543-1.24-1.207-1.24-.671 0-1.215.554-1.215 1.24 0 .678.544 1.233 1.215 1.233.664 0 1.207-.555 1.207-1.233zM16.541 16.767c0-.686-.543-1.24-1.207-1.24-.671 0-1.215.554-1.215 1.24 0 .678.543 1.233 1.215 1.233.664 0 1.207-.555 1.207-1.233z","fill":"#94A3B8"}})])
          )
        }
      }
    